import { Card } from "./ui/card";
import { Banknote, PiggyBank, CreditCard } from "lucide-react";

export type AccountType = "Checking" | "Savings" | "Credit";

const icons = {
  Checking: <Banknote className="text-blue-500" size={24} />,
  Savings: <PiggyBank className="text-teal-500" size={24} />,
  Credit: <CreditCard className="text-purple-500" size={24} />,
};

interface AccountWidgetProps {
  type: AccountType;
  balance: string;
  number: string;
}

const AccountWidget = ({ type, balance, number }: AccountWidgetProps) => (
  <Card className="flex flex-col justify-between bg-card/90 rounded-xl shadow-md px-4 py-5 min-w-[160px]">
    <div className="mb-2 flex items-center gap-2">
      {icons[type]}
      <span className="font-medium text-lg">{type}</span>
    </div>
    <div className="text-2xl font-bold mb-1">{balance}</div>
    <div className="text-xs text-muted-foreground">•••{number.slice(-4)}</div>
  </Card>
);

export default AccountWidget;
